// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__11jKC","title":"InfoRow_title__3uCNi"};